<template>
  <div :class="googleorsocial.type">
    <div
      class="advertising-title"
      v-if="slotTitle"
    >
      <slot name="title"></slot>
    </div>
    <div class="advertising-data">
      <div
        v-for="item in googleorsocial.list"
        class="advertising-item"
        :key="item.id"
        :class="item.class"
        :style="[googleorsocial.itemStyle,{background:`url(${item.bgUrl}) no-repeat right top`}]"
      >
        <div class="item-top">
          <div class="item-data">
            <div class="data-title">
              <span>{{ item.title }}</span>
              <el-tooltip
                v-if="item.message"
                class="item"
                effect="dark"
                :content="item.message.content"
                :placement="item.message.site"
              >
                <ig-icon name="tishi"></ig-icon>
              </el-tooltip>

            </div>
            <div
              class="data"
              v-if="item&&item.tooltipData"
            >
              <el-popover
                class="item"
                trigger="hover"
                :placement="item.message.site"
              >
                <div>
                  <div
                    class="slot-content"
                    v-for="(value,key) in item.tooltipData"
                    :key="key"
                  >{{key}}：{{value}}
                  </div>
                </div>
                <span slot="reference">{{ item.data }}</span>
              </el-popover>
            </div>
            <div
              v-else
              class="data"
            >{{ item.data }}</div>

            <div
              v-if="item.message && item.message.subtitle"
              class="data-subtitle"
            >{{item.message && item.message.subtitle}}</div>
          </div>
          <div
            v-if="item.icon"
            class="item-icon"
          >
            <div
              class="icon"
              :style="item.iconBgc"
              :class="item.icon"
            >
              <div
                class="ig-icon"
                :style="
                  typeof item.iconStyle == 'function'
                    ? item.iconStyle(item)
                    : item.iconStyle
                "
                :class="item.icon"
              >
                <ig-icon :name="item.icon"></ig-icon>
              </div>
            </div>
          </div>
        </div>
        <div
          class="item-bottom"
          :class="item.state > 0 ? 'shangsheng' : 'xiajiang'"
          v-if="googleorsocial.bottom"
        >
          <slot name="bottom-name">
            <div>相比前一周</div>
          </slot>
          <div>
            <ig-icon :name="item.state > 0 ? 'shangsheng' : 'xiajiang'"></ig-icon>
          </div>
          <div>{{ item.rate }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import clientModule from '@/components/client/clientModule/clientModule'
import popover from '@/components/task/taskList/popover.vue'
export default {
  name: 'googlorsocial',
  props: {
    googleorsocial: {
      type: Object,
    },
    slotTitle: {
      type: Boolean,
      default: true,
    },
  },
  components: { clientModule, popover },
  methods: {},
}
</script>
<style scoped lang="scss">
.slot-content {
  line-height: 28px;
  white-space: nowrap;
}
.google,
.socialmedia,
.websiteData,
.collect {
  .advertising-title {
    padding: 24px;
    margin-bottom: 6px;
  }
  .advertising-data {
    width: 100%;
    padding: 0 14px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    .advertising-item {
      flex: 1;
      height: 100%;
      margin: 0 7px;
      padding: 1% 1% 0;
      box-shadow: 0px 2px 4px 0px rgba(51, 51, 51, 0.1);
      border-radius: 2px;
      .item-top {
        height: 100px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        border-bottom: 1px solid #e8e8e8;
        .item-data {
          .data {
            font-size: 30px;
            color: #333;
            font-weight: bold;
            margin-top: 5px;
            cursor: pointer;
          }
          .data-title {
            white-space: nowrap;
          }
          .data-title .iconfont {
            font-size: 12px;
            color: #999;
            margin-left: 5px;
          }
          .data-subtitle {
            color: #999999;
            font-size: 12px;
            margin-top: 0px;
            white-space: nowrap;
          }
        }
        .item-icon {
          width: 70px;
          height: 100%;
          display: flex;
          align-items: center;
          margin-right: 1%;
          .icon {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            .ig-icon {
              width: 54px;
              height: 54px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 50%;
              background-color: #fff;
              i {
                font-size: 56px;
              }
              &.zhanshiliang {
                color: #ff9fa5;
              }
              &.dianjilv {
                color: #79f5fe;
              }
              &.zongxiaohao {
                color: #9febd4;
              }
              &.dianjijunjia {
                color: #adc5ff;
              }
              &.liebiaoxunpan {
                color: #88c7fd;
              }
            }
            &.zhanshiliang {
              background-color: #fff5f4;
            }
            &.dianjilv {
              background-color: #eeffff;
            }
            &.zongxiaohao {
              background-color: #e7faf3;
            }
            &.dianjijunjia {
              background-color: #e3ebff;
            }
            &.liebiaoxunpan {
              background-color: #ddeef8;
            }
          }
        }
      }
      .item-bottom {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        &.shangsheng {
          i {
            color: #f5222d;
            margin: 0 6px;
            font-size: 12px;
          }
        }
        &.xiajiang {
          i {
            color: #52c41a;
            margin: 0 6px;
            font-size: 12px;
          }
        }
      }
    }
  }
}
.socialmedia {
  min-width: 558px;
  .advertising-data {
    flex-wrap: wrap;
    margin-bottom: 0;
    .advertising-item {
      // min-width: 243px;
      height: 140px;
      margin: 0px 11px 25px;
      padding: 0;
      .item-top {
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 20px;
        padding-right: 14px;
        box-sizing: border-box;
        .item-data {
          .data-title {
            white-space: nowrap;
            font-size: 12px;
            color: #666;
          }
          .data {
            font-size: 26px;
            color: #333;
          }
        }
        .item-icon {
          width: 76px;
          margin: 0;
          .icon {
            width: 76px;
            height: 76px;
            border-radius: 0;
            .ig-icon {
              width: 100%;
              height: 100%;
              line-height: 76px;
              border-radius: 0;
              i {
                font-size: 74px;
              }
              &.liulanliang {
                color: #5c9bdd;
              }
              &.fugairenshu {
                color: #b5dd9c;
              }
              &.fensishu {
                color: #ff7d7f;
              }
              &.hudongshu {
                color: #7f61ef;
              }
            }
          }
        }
      }
    }
  }
}
.websiteData {
  min-width: 558px;
  .advertising-data {
    flex-wrap: wrap;
    margin-bottom: 0;
    .advertising-item {
      // min-width: 243px;
      height: 140px;
      margin: 0px 11px 25px;
      padding: 0;
      position: relative;
      .item-top {
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 20px;
        padding-right: 14px;
        box-sizing: border-box;
        .item-data {
          .data-title {
            white-space: nowrap;
            font-size: 12px;
            color: #666;
          }
          .data {
            font-size: 26px;
            color: #333;
          }
        }
        .item-icon {
          width: 76px;
          margin: 0;
          .icon {
            width: 76px;
            height: 76px;
            border-radius: 0;
            .ig-icon {
              width: 100%;
              height: 100%;
              line-height: 76px;
              border-radius: 0;
              i {
                font-size: 74px;
              }
              &.liulanliang {
                color: #5c9bdd;
              }
              &.fugairenshu {
                color: #b5dd9c;
              }
              &.fensishu {
                color: #ff7d7f;
              }
              &.hudongshu {
                color: #7f61ef;
              }
            }
          }
        }
      }
      &.one::after,
      &.two::after,
      &.three::after,
      &.four::after,
      &.five::after {
        content: '';
        width: 100%;
        height: 8px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      &.one::after {
        background-color: #ff9fa4;
      }
      &.two::after {
        background-color: #b5dd9d;
      }
      &.three::after {
        background-color: #5b9bdd;
      }
      &.four::after {
        background-color: #aec4ff;
      }
      &.five::after {
        background-color: #94eff7;
      }
    }
  }
}
.collect {
  min-width: 558px;
  padding: 0 24px;
  .advertising-data {
    flex-wrap: wrap;
    margin: 0;
    padding: 30px 0;
    .advertising-item {
      min-width: 186px;
      height: 100px;
      margin: 0 3px;
      padding: 0;
      .item-top {
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 20px;
        box-sizing: border-box;
        .item-data {
          .data-title {
            white-space: nowrap;
            font-size: 12px;
            color: #666;
          }
          .data {
            font-size: 26px;
            color: #333;
          }
        }
        .item-icon {
          width: 73px;
          margin: 0;
          .icon {
            width: 100%;
            height: 100%;
            border-radius: 0;
            .ig-icon {
              width: 100%;
              height: 100%;
              border-radius: 0;
              display: flex;
              align-items: flex-end;
              i {
                font-size: 70px;
                position: relative;
                right: 0px;
                bottom: -4px;
              }
              &.liulanliangs {
                color: #e1f0ff;
              }
              &.xiansuoshu {
                color: #ece8ff;
              }
              &.xunpanshu {
                color: #e4feda;
              }
            }
          }
        }
      }
    }
  }
}
// 小语种
.mini-lang {
  .advertising-title {
    padding: 24px;
    margin-bottom: 6px;
  }
  .advertising-data {
    width: 100%;
    padding: 0 14px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    .advertising-item {
      flex: 1;
      height: 100%;
      margin: 0 7px;
      padding: 1% 1% 0;
      box-shadow: 0px 2px 4px 0px rgba(51, 51, 51, 0.1);
      border-radius: 2px;
      .item-top {
        height: 75px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        border-bottom: 1px solid #e8e8e8;
        .item-data {
          .data {
            font-size: 26px;
            color: #333;
            font-weight: bold;
            margin-top: 5px;
            cursor: pointer;
          }
          .data-title {
            white-space: nowrap;
          }
          .data-title .iconfont {
            font-size: 12px;
            color: #999;
            margin-left: 5px;
          }
          .data-subtitle {
            color: #999999;
            font-size: 12px;
            margin-top: 0px;
            white-space: nowrap;
          }
        }
      }
      .item-bottom {
        width: 100%;
        padding: 8px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        &.shangsheng {
          i {
            color: #f5222d;
            margin: 0 6px;
            font-size: 12px;
          }
        }
        &.xiajiang {
          i {
            color: #52c41a;
            margin: 0 6px;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
